import type { DayStat, MonthStat } from "./CalendarWidget";
import { ProfitBadge } from "./ProfitBadge";

interface InfoPanelProps {
  hoveredDay: DayStat | null;
  monthSummary: MonthStat | null;
}

const formatDate = (iso: string) => {
  const d = new Date(iso);
  const day = d.getDate();
  const m = d.getMonth() + 1;
  const y = d.getFullYear();
  return `${day}.${m}.${y}`;
};

export const InfoPanel = ({ hoveredDay, monthSummary }: InfoPanelProps) => {
  const src = hoveredDay ?? monthSummary ?? null;

  const profit = src?.profitUsd ?? 0;
  const percent = src?.percent ?? 0;
  const trades = src?.trades ?? 0;

  const dateLabel = hoveredDay ? formatDate(hoveredDay.date) : "—";

  return (
    <div className="flex w-full flex-col gap-5">
      {/* Header with badges */}
      <div className="flex flex-col gap-2">
        <div className="flex items-start gap-2">
          <ProfitBadge
            value={profit}
            type="currency"
            size="md"
            showArrow={false}
          />
          <ProfitBadge
            value={percent}
            type="percent"
            size="sm"
          />
        </div>
      </div>

      {/* Details */}
      <div className="flex flex-col gap-3">
        {/* Date */}
        <div className="flex flex-col gap-1">
          <span className="fs-200 text-neutral-50/50">Дата:</span>
          <span className="fs-300 font-semibold text-neutral-100">{dateLabel}</span>
        </div>

        {/* Trades */}
        <div className="flex flex-col gap-1">
          <span className="fs-200 text-neutral-50/50">Сделок:</span>
          <span className="fs-300 font-semibold text-neutral-100">{trades}</span>
        </div>
      </div>
    </div>
  );
};
